import { DTOEventDataSourcesImported, DTOEventFigmaNodesRendered, } from "./design-system";
import { z } from "zod";
export const DTOEvent = z.discriminatedUnion("type", [
    DTOEventDataSourcesImported,
    DTOEventFigmaNodesRendered,
]);
